export default __webpack_public_path__ + "src/assets/Ledger_Desktop.1a24b3152530b2b0e4886f81e0ccee76.svg";